import { Services } from '@smiles/voebiz-core-corporate-club';
import { CorporateClubMemberExtractParamType } from '@smiles/voebiz-core-corporate-club/dist/Types/GetCorporateClubMemberExtractApi.types';
import { IGetListPurchaseMilesByBeneficiaryParams } from '@smiles/voebiz-core-corporate-club/dist/Types/GetListPurchaseMilesByBeneficiaryApi.types';

export function getMemberExtract(params: CorporateClubMemberExtractParamType) {
  return Services.getCorporateClubMemberExtract(params);
}
export function getMemberHistory(params: IGetListPurchaseMilesByBeneficiaryParams) {
  console.log('params: ', params);
  return Services.getListPurchaseMilesByBeneficiary(params);
}
